import { RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.subsidiaryOrganization,
    element: loadable(() => import('./pages/SubsidiaryOrganizationPage')),
  },
];
